import { getInterfacesUrl } from "lib/route-helpers";
import { blockType } from "../constants";
import { MediaBlockSchema } from "../schema";
import { Media } from "../types";

export const create: Media["create"] = () => {
  return MediaBlockSchema.parse({
    type: blockType,
    config: {
      mediaType: "image",
      mediaSource: "url",
      mediaUrl: `${getInterfacesUrl()}/media.png`,
      height: 200,
      alignContent: "center",
      style: {
        width: "narrow",
        alignment: "center",
      },
    },
  });
};
